import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

function StoreAdd() {
  const [generalSaved, setGeneralSaved] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const saved = localStorage.getItem("generalSaved") === "true";
    setGeneralSaved(saved);
  }, [location]);

  const navLinkClass = (isDisabled) => (isDisabled ? "disabled" : "");

  return (
    <>
      <div className="content settings-content">
        <div className="page-header settings-pg-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Add New Store</h4>
              <h6>Manage your settings on of Store</h6>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="settings-wrapper d-flex">
              <div className="settings-sidebar" id="sidebar2">
                <div className="sidebar-inner slimscroll">
                  <div id="sidebar-menu5" className="sidebar-menu">
                    <h4 className="fw-bold fs-18 mb-2 pb-2">Store Settings</h4>
                    <ul className="store-setting-tabs">
                      <li>
                        <NavLink to="general">
                          <i className="ti ti-settings fs-18" />
                          <span className="fs-14 fw-medium ms-2">
                            General Settings
                          </span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="social-media"
                          className={navLinkClass(!generalSaved)}
                          style={
                            !generalSaved
                              ? { pointerEvents: "none", opacity: 0.5 }
                              : {}
                          }
                        >
                          <i className="ti ti-world fs-18" />
                          <span className="fs-14 fw-medium ms-2">
                            Social Media Settings
                          </span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="payment-gateway"
                          className={navLinkClass(!generalSaved)}
                          style={
                            !generalSaved
                              ? { pointerEvents: "none", opacity: 0.5 }
                              : {}
                          }
                        >
                          <i className="ti ti-receipt-refund fs-18" />
                          <span className="fs-14 fw-medium ms-2">
                            Payment Gateway Settings
                          </span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="shipping-settings"
                          className={navLinkClass(!generalSaved)}
                          style={
                            !generalSaved
                              ? { pointerEvents: "none", opacity: 0.5 }
                              : {}
                          }
                        >
                          <i className="ti ti-mail fs-18" />
                          <span className="fs-14 fw-medium ms-2">
                            Shipping Settings
                          </span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="warehouse-settings"
                          className={navLinkClass(!generalSaved)}
                          style={
                            !generalSaved
                              ? { pointerEvents: "none", opacity: 0.5 }
                              : {}
                          }
                        >
                          <i className="ti ti-location fs-18" />
                          <span className="fs-14 fw-medium ms-2">
                            Pickup Address Settings
                          </span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="email-settings"
                          className={navLinkClass(!generalSaved)}
                          style={
                            !generalSaved
                              ? { pointerEvents: "none", opacity: 0.5 }
                              : {}
                          }
                        >
                          <i className="ti ti-mail fs-18" />
                          <span className="fs-14 fw-medium ms-2">
                            Email Settings
                          </span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="sms-settings"
                          className={navLinkClass(!generalSaved)}
                          style={
                            !generalSaved
                              ? { pointerEvents: "none", opacity: 0.5 }
                              : {}
                          }
                        >
                          <i className="ti ti-message fs-18" />
                          <span className="fs-14 fw-medium ms-2">
                            Sms Settings
                          </span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="sms-templates"
                          className={navLinkClass(!generalSaved)}
                          style={
                            !generalSaved
                              ? { pointerEvents: "none", opacity: 0.5 }
                              : {}
                          }
                        >
                          <i className="ti ti-device-mobile-message fs-18"></i>
                          <span className="fs-14 fw-medium ms-2">
                            Sms Templates
                          </span>
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card flex-fill mb-0 w-50">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StoreAdd;
